import { b as a, c as n } from "../../../filters-Cwo0Aj2k.js";
const r = (e) => {
  switch (e.predicate.operator) {
    case a.Match:
      return {
        type: n.dimension,
        predicate: e.predicate,
        dimensionCode: e.reference.code,
        reference: e.reference,
        isValid: e.isValid,
        dataType: e.dataType
      };
    case a.Like:
      return {
        type: n.dimension,
        predicate: e.predicate,
        dimensionCode: e.reference.code,
        reference: e.reference,
        isValid: e.isValid,
        dataType: e.dataType
      };
    case a.IN:
      return {
        type: n.dimension,
        predicate: e.predicate,
        dimensionCode: e.reference.code,
        reference: e.reference,
        isValid: e.isValid,
        dataType: e.dataType
      };
    case a.EQ:
    case a.GTE:
    case a.GT:
    case a.LT:
    case a.LTE:
      return {
        predicate: e.predicate,
        dimensionCode: e.reference.code,
        type: n.dimension,
        reference: e.reference,
        isValid: e.isValid,
        dataType: e.dataType
      };
    case a.BETWEEN:
      return {
        predicate: e.predicate,
        dimensionCode: e.reference.code,
        type: n.dimension,
        reference: e.reference,
        isValid: e.isValid,
        dataType: e.dataType
      };
    default:
      return e.predicate;
  }
};
export {
  r as consolidateUniversalConfFilterToDimension
};
//# sourceMappingURL=DimensionFilterSelector.utils.js.map
